import { render } from "./ListeFacturePage.vue?vue&type=template&id=6ec4b372&ts=true"
import script from "./ListeFacturePage.vue?vue&type=script&lang=ts"
export * from "./ListeFacturePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__